import LinkInternal from '../LinkInternal';
import Item from '../Item';

export default [
    {
        component: Item,
        props: {
            render: new LinkInternal({
                id: 'infoMAP',
                text: 'Informace o aplikaci Mapka',
            }),
        },
    },
    {
        component: Item,
        props: {
            render: new LinkInternal({
                id: 'howto',
                text: 'Jak pracovat s&nbsp;Mapkou',
            }),
        },
    },
    {
        component: Item,
        props: {
            render: new LinkInternal({
                id: 'howToAttribute',
                text: 'Jak citovat Mapku',
            }),
        },
    },
];
